import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import oppService from "@/service/opp-service";
import dict from "@/tools/dict";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var SAVE_PATH3 = "";
var SAVE_PATH4 = "";
var SAVE_PATH5 = "";

var backfillOldData = function backfillOldData(_this) {
  var orgBasicInfo = _this.oppBusiData.oldBusiData.orgBasicInfo;
  if (!_.isEmpty(orgBasicInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], orgBasicInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var orgBasicInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  var orgBasicInfo2 = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
  var orgBasicInfo3 = _.cloneDeepGet(_this.historyData, SAVE_PATH3);
  var extinfo = _.cloneDeepGet(_this.historyData, SAVE_PATH4);
  var extinfo2 = _.cloneDeepGet(_this.historyData, SAVE_PATH5);
  orgBasicInfo = _Object$assign({}, orgBasicInfo, orgBasicInfo2, orgBasicInfo3, extinfo, extinfo2);
  if (!_.isEmpty(orgBasicInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], orgBasicInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], orgBasicInfo);
  }
};

var myParseFloat = function myParseFloat(s) {
  var result = parseFloat(s);
  return isNaN(result) ? 0 : result;
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  var basicInfo = _this.oppBusiData.basicInfo || {};
  _.set(fields, "CITIZENSHIP.FIELD_TYPE", "selector");
  if (fields.REGISTER_CURRENCY && basicInfo && basicInfo.currency) {
    if (basicInfo.currency == "RMB") {
      fields.REGISTER_CURRENCY.DEFAULT_VALUE = "CNY";
    } else {
      fields.REGISTER_CURRENCY.DEFAULT_VALUE = basicInfo.currency;
    }
    fields.CITIZENSHIP.DATA_SOURCE = "2";
    fields.REGISTER_CURRENCY.DATA_SOURCE = "2";
  }
  if (fields.REGISTER_FUND && basicInfo.regCapital) {
    fields.REGISTER_FUND.DEFAULT_VALUE = basicInfo.regCapital * 10000 + "";
    fields.REGISTER_FUND.DATA_SOURCE = "2";
  }
  if (fields.CORP_ADDR && basicInfo.officeAddr) {
    fields.CORP_ADDR.DEFAULT_VALUE = basicInfo.officeAddr;
    fields.CORP_ADDR.DATA_SOURCE = "2";
  }
  if (fields.ID_ZIP_CODE && basicInfo.officePostCd) {
    fields.ID_ZIP_CODE.DEFAULT_VALUE = basicInfo.officePostCd;
    fields.ID_ZIP_CODE.DATA_SOURCE = "2";
  }

  var szorgTypeDict = _.map(fields.SZORG_TYPE.FIELD_DICT_NAME, function (item) {
    return item.DICT_ITEM;
  }),
      szorgTypeFilter = [];
  fields.STRUCT_PRO_FLAG.FIELD_TYPE = "radio";
  if (_this.openAcctType == "1") {
    _.each(szorgTypeDict, function (item) {
      if (["15", "51", "52", "99a", "99b", "10", "11", "12", "13", "14", "33", "34", "41"].indexOf(item) === -1) {
        szorgTypeFilter.push(item);
      }
    });
    fields.STRUCT_PRO_FLAG.FIELD_CONTROL = "1";
    fields.INIT_LEVERAGE.FIELD_CONTROL = "1";
  } else {
    szorgTypeFilter = ["15", "51", "52", "99a", "99b", "10", "11", "12", "13", "14", "33", "34", "41"];
    fields.STRUCT_PRO_FLAG.FIELD_CONTROL = "0";
    fields.INIT_LEVERAGE.FIELD_CONTROL = "1";
  }
  fields.SZORG_TYPE.FIELD_DICT_FILTER = szorgTypeFilter;

  _.set(fields, "REGISTER_FUND.IS_SHOW_CHECKBOX", true);

  _.set(fields, "LISTED_ATTR.FIELD_FUNCTION", "CHECK_LISTED_ATTR");

  _.set(fields, "REGISTER_FUND.PLACE_HOLDER", "请输入:" + fields.REGISTER_FUND.FIELD_TITLE);
  _.set(fields, "HAS_CORP_QUAL.FIELD_TYPE", "radio");
  _.set(fields, "HAS_CORP_QUAL.isLongItem", true);
  _.set(fields, "LISTED_ATTR.FIELD_TYPE", "radio");
  _.set(fields, "INDUS_TYPE.FIELD_TYPE", "selector");
  _.set(fields, "INDUS_TYPE.FIELD_DICT", "INDUS_EXTYPE");
  _.set(fields, "INDUS_TYPE.FIELD_DICT_NAME", _this.oppBusiData.INDUS_EXTYPE_DICT);
  _.set(fields, "REGISTER_FUND.VALID_TYPE", "moneyExpand[12,2]");
  _.set(fields, "CORP_QUAL_ID_NAME.VALID_TYPE", "length[0,128]");
  _.set(fields, "CORP_QUAL_ID_CODE.VALID_TYPE", "length[0,48]");
  _.set(fields, "CORP_QUAL_ID_ISS_AGCY_PRO.VALID_TYPE", "length[0,256]");
  _.set(fields, "CORP_QUAL_PERMIT.VALID_TYPE", "length[0,256]");
  _.set(fields, "SMFUND_MANAGER_ID.VALID_TYPE", "length[0,20]");
  _.set(fields, "CORP_ADDR.FIELD_FUNCTION", "USE_ID_ADDRESS|CHECK_CORP_ADDR");

  _.set(fields, "CORP_ADDR.VALID_TYPE", "length[16,128]");

  _this.busiCode == "QS420" && _.set(fields, "RISK_FACTOR.splitFlag", "");
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
    SAVE_PATH3 = params.savePath3;
    SAVE_PATH4 = params.savePath4;
    SAVE_PATH5 = params.savePath5;
  },

  beforeLoadBiz: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dict.getDictData("INDUS_EXTYPE").then(function (res) {
                _this.oppBusiData.INDUS_EXTYPE_DICT = res.INDUS_EXTYPE;
                initFieldConfig(_this);
                if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
                  backfillOldData(_this);
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeLoadBiz(_x2) {
      return _ref.apply(this, arguments);
    }

    return beforeLoadBiz;
  }(),

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
    if (_.get(_this, "historyData.BIZ_DATA.BASE_INFO.REGISTER_FUND", "") == "0") {
      _.set(_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, "REGISTER_FUND.isCheckCheckbox", true);
      _.set(_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, "REGISTER_FUND.DEFAULT_VALUE", "0");
      _.set(_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, "REGISTER_FUND.FIELD_REQUIRED", "0");
      _.set(_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, "REGISTER_FUND.FIELD_CONTROL", "2");
      _.set(_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, "REGISTER_FUND.VALID_TYPE", "");
    }
    var field = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.SZORG_TYPE;
    if (["21", "22", "23", "25a"].includes(field.DEFAULT_VALUE)) {
      _.each(_this.groupDatas.OTHER_INFO_PAGE.PARTNER_MODULE, function (item) {
        item.MODULE_CONTROL = "1";
      });
      _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].MODULE_TITLE = "执行事务合伙人";
    } else {
      _.each(_this.groupDatas.OTHER_INFO_PAGE.PARTNER_MODULE, function (item) {
        item.MODULE_CONTROL = "0";
      });
      _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].MODULE_TITLE = "法定代表人";
    }
    _this.oppBusiData.isShowBeneficiaryTypeAlert = _.get(_this, "historyData.DETAIL_DATA.isShowBeneficiaryTypeAlert") || "0";
  },
  preValidate: function preValidate(_this) {
    _this.removeFlowTip("indusGbJ");
  },
  beforeSave: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this, params, baseData) {
      var orgBasicInfo, baseInfoKeyArr, contractKeyArr, extInfoKeyArr, baseInfoKeyArrDataSource, contractKeyArrDataSource, extKeyArrDataSource, baseInfoKeyArrUpdateFlag, contractKeyArrUpdateFlag, extKeyArrUpdateFlag, CUST_CLS, SPECIAL_ORG_CLS, OPENTMPL_INFO;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.removeFlowTip("indusGbJ");
              orgBasicInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH4]);
              baseInfoKeyArr = ["CITIZENSHIP", "SZORG_TYPE", "REGISTER_CURRENCY", "REGISTER_FUND", "CAPITAL_ATTR", "NATIONAL_ATTR", "LISTED_ATTR", "SMFUND_MANAGER_ID", "PROF_INVESTOR_SOURCE"], contractKeyArr = ["ID_ZIP_CODE", "RISK_FACTOR", "CORP_ADDR"], extInfoKeyArr = ["INDUS_TYPE", "INDUS_GB", "CORP_QUAL_ID_CODE", "CORP_QUAL_ID_EXP_DATE", "CORP_QUAL_ID_ISS_AGCY_PRO", "CORP_QUAL_ID_NAME", "CORP_QUAL_PERMIT"];

              if (_this.$store.state.openAcctType == "2") {
                baseInfoKeyArr.push("STRUCT_PRO_FLAG");
                baseInfoKeyArr.push("INIT_LEVERAGE");
              }
              baseInfoKeyArrDataSource = _.map(baseInfoKeyArr, function (item) {
                return item + "_DATA_SOURCE";
              });
              contractKeyArrDataSource = _.map(contractKeyArr, function (item) {
                return item + "_DATA_SOURCE";
              });
              extKeyArrDataSource = _.map(extInfoKeyArr, function (item) {
                return item + "_DATA_SOURCE";
              });
              baseInfoKeyArrUpdateFlag = _.map(baseInfoKeyArr, function (item) {
                return item + "_UPDATE_FLAG";
              });
              contractKeyArrUpdateFlag = _.map(contractKeyArr, function (item) {
                return item + "_UPDATE_FLAG";
              });
              extKeyArrUpdateFlag = _.map(extInfoKeyArr, function (item) {
                return item + "_UPDATE_FLAG";
              });

              baseInfoKeyArr = [].concat(_toConsumableArray(baseInfoKeyArr), _toConsumableArray(baseInfoKeyArrDataSource), _toConsumableArray(baseInfoKeyArrUpdateFlag));
              contractKeyArr = [].concat(_toConsumableArray(contractKeyArr), _toConsumableArray(contractKeyArrDataSource), _toConsumableArray(contractKeyArrUpdateFlag));
              extInfoKeyArr = [].concat(_toConsumableArray(extInfoKeyArr), _toConsumableArray(extKeyArrDataSource), _toConsumableArray(extKeyArrUpdateFlag));
              if (_this.$store.state.openAcctType != 3) {
                if (_this.oppBusiData.MECHANISM_PRO_INVESTORS_I.indexOf(orgBasicInfo.SZORG_TYPE) !== -1) {
                  orgBasicInfo["PROF_INVESTOR_SOURCE"] = "10";
                } else {
                  orgBasicInfo["PROF_INVESTOR_SOURCE"] = "00";
                }
              } else {
                orgBasicInfo["PROF_INVESTOR_SOURCE"] = "10";
              }

              baseData.SZORG_TYPE = orgBasicInfo.SZORG_TYPE;
              _context2.next = 17;
              return oppService.getBusiCommonParamsFromCacheObjs("CUST_CLS");

            case 17:
              CUST_CLS = _context2.sent;
              _context2.next = 20;
              return oppService.getBusiCommonParamsFromCacheObjs("SPECIAL_ORG_CLS");

            case 20:
              SPECIAL_ORG_CLS = _context2.sent;
              OPENTMPL_INFO = _this.oppBusiData.OPENTMPL_INFO || {};

              if (!!CUST_CLS && SPECIAL_ORG_CLS.includes(orgBasicInfo.SZORG_TYPE)) {
                OPENTMPL_INFO.OLD_CUST_CLS = OPENTMPL_INFO.OLD_CUST_CLS || OPENTMPL_INFO.CUST_CLS;
                OPENTMPL_INFO.CUST_CLS = CUST_CLS;
                consoleLog("获取了业务公参的客户分类", CUST_CLS);
              }
              orgBasicInfo.CHANNELS = OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CHANNELS || "";
              orgBasicInfo.CUST_CLS = OPENTMPL_INFO && OPENTMPL_INFO.CUST_CLS || "";

              baseData.YZT_RISK_FACTOR = orgBasicInfo.RISK_FACTOR || "-1";
              params.BIZ_DATA.CUST_CLS = OPENTMPL_INFO && OPENTMPL_INFO.CUST_CLS || "";
              if (!_.isEmpty(_this.oppBusiData.OPENTMPL_INFO)) {
                _.set(params, "BIZ_DATA.OPENTMPL_INFO", _this.oppBusiData.OPENTMPL_INFO || {});
              }
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3, SAVE_PATH4], orgBasicInfo);

              _.set(params, SAVE_PATH, _Object$assign(_.get(params, SAVE_PATH, {}), _.pick(orgBasicInfo, baseInfoKeyArr)));

              _.set(params, SAVE_PATH2, _Object$assign(_.get(params, SAVE_PATH2, {}), _.pick(orgBasicInfo, contractKeyArr)));

              _.set(params, SAVE_PATH3, _Object$assign(_.get(params, SAVE_PATH3, {}), { CORP_ADDR: orgBasicInfo.CORP_ADDR, ID_ZIP_CODE: orgBasicInfo.ID_ZIP_CODE }));

              _.set(params, SAVE_PATH4, _Object$assign(_.get(params, SAVE_PATH4, {}), _.pick(orgBasicInfo, extInfoKeyArr)));
              _.set(params, SAVE_PATH5, _Object$assign(_.get(params, SAVE_PATH5, {}), { HAS_CORP_QUAL: orgBasicInfo.HAS_CORP_QUAL }));
              params.DETAIL_DATA.isShowBeneficiaryTypeAlert = _this.oppBusiData.isShowBeneficiaryTypeAlert;

              if (["21", "22", "23", "25a"].indexOf(orgBasicInfo.SZORG_TYPE) === -1) {
                params.BIZ_DATA.PARTNER_INFO_LIST = [];
              }

            case 36:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function beforeSave(_x3, _x4, _x5) {
      return _ref2.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this) {
      var customerInfo, res, OPENTMPL_INFO;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
              _context3.next = 3;
              return _this.$syscfg.K_Request("F0000019", {
                ORG_CODE: customerInfo.INT_ORG,
                USER_TYPE: _this.$store.state.openAcctType == "3" ? "2" : "1"
              });

            case 3:
              res = _context3.sent;
              OPENTMPL_INFO = _.get(res, "Data[0]", {});

              if (OPENTMPL_INFO.CUST_CLS) {
                _context3.next = 8;
                break;
              }

              this.alert("客户模板中客户分类字段缺失！");
              return _context3.abrupt("return", false);

            case 8:
              if (OPENTMPL_INFO.CHANNELS) {
                _context3.next = 11;
                break;
              }

              this.alert("客户模板中操作渠道字段缺失！");
              return _context3.abrupt("return", false);

            case 11:
              if (OPENTMPL_INFO.CUACCT_CLS) {
                _context3.next = 14;
                break;
              }

              this.alert("客户模板中资金类别字段缺失！");
              return _context3.abrupt("return", false);

            case 14:
              if (OPENTMPL_INFO.CUACCT_LVL) {
                _context3.next = 17;
                break;
              }

              this.alert("客户模板中资产级别字段缺失！");
              return _context3.abrupt("return", false);

            case 17:
              if (OPENTMPL_INFO.CUACCT_GRP) {
                _context3.next = 20;
                break;
              }

              this.alert("客户模板中资产组别字段缺失！");
              return _context3.abrupt("return", false);

            case 20:
              if (OPENTMPL_INFO.CUACCT_ATTR) {
                _context3.next = 23;
                break;
              }

              this.alert("客户模板中资产属性字段缺失！");
              return _context3.abrupt("return", false);

            case 23:
              _this.oppBusiData.OPENTMPL_INFO = OPENTMPL_INFO;

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function validate(_x6) {
      return _ref3.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
    var idType = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
    if (["10", "11", "12", "13"].indexOf(idType) != -1) {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.DEFAULT_VALUE = "CHN";
    } else {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.FIELD_CONTROL = "0";
    }
    if (_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.isCheckCheckbox) {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.DEFAULT_VALUE = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_REQUIRED = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.VALID_TYPE = "";
    } else {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_REQUIRED = "1";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_CONTROL = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.VALID_TYPE = "moneyExpand[12,2]";
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  CHECK_SUBJECT_IDENTITY: function CHECK_SUBJECT_IDENTITY(_this, field, fields) {},
  CHECK_NATIVE_PLACE: function CHECK_NATIVE_PLACE(_this, field, fields) {},
  "CHECK_LISTED_ATTR": function CHECK_LISTED_ATTR(_this, field, fieldData) {
    var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  },
  CHECK_REGISTER_FUND: function CHECK_REGISTER_FUND(_this, field, fieldData) {
    var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  },

  "CHECK_SZORG_TYPE": function CHECK_SZORG_TYPE(_this, field, fieldData) {

    if (_this.$store.state.canCleanData) {
      if (_this.$store.state.canCleanData) {
        _.each(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE, function (mdd) {
          if (mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE != "") {
            mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE = "";
            _this.oppBusiData.isShowBeneficiaryTypeAlert = "1";
          }
        });
      }
      fieldData["SMFUND_MANAGER_ID"].DEFAULT_VALUE = "";
    }
    if (["25", "25a", "25b"].includes(field.DEFAULT_VALUE)) {
      fieldData["SMFUND_MANAGER_ID"].FIELD_CONTROL = "0";
      fieldData["SMFUND_MANAGER_ID"].FIELD_REQUIRED = "1";
    } else {
      fieldData["SMFUND_MANAGER_ID"].correct = false;
      fieldData["SMFUND_MANAGER_ID"].FIELD_REQUIRED = "0";
      fieldData["SMFUND_MANAGER_ID"].FIELD_CONTROL = "1";
    }

    if (["21", "22", "23", "25a"].includes(field.DEFAULT_VALUE)) {
      _.each(_this.groupDatas.OTHER_INFO_PAGE.PARTNER_MODULE, function (item) {
        item.MODULE_CONTROL = "1";
      });
      _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].MODULE_TITLE = "执行事务合伙人";
    } else {
      _.each(_this.groupDatas.OTHER_INFO_PAGE.PARTNER_MODULE, function (item) {
        item.MODULE_CONTROL = "0";
      });
      _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].MODULE_TITLE = "法定代表人";
    }
  },
  CHECK_REGISTER_FUND__CLICK: function CHECK_REGISTER_FUND__CLICK(_this, field, fieldData) {
    if (field.isCheckCheckbox) {
      field.DEFAULT_VALUE = "0";
      field.FIELD_REQUIRED = "0";
      field.FIELD_CONTROL = "2";
      field.VALID_TYPE = "";
    } else {
      field.VALID_TYPE = "moneyExpand[12,2]";
      field.DEFAULT_VALUE = "";
      field.FIELD_REQUIRED = "1";
      field.FIELD_CONTROL = "0";
    }
  },

  CHECK_HAS_CORP_QUAL: function CHECK_HAS_CORP_QUAL(_this, field, fieldData) {
    var hasCorpQual = field.DEFAULT_VALUE === "1";
    ["CORP_QUAL_ID_NAME", "CORP_QUAL_ID_CODE", "CORP_QUAL_ID_EXP_DATE", "CORP_QUAL_ID_ISS_AGCY_PRO", "CORP_QUAL_PERMIT"].map(function (fk) {
      var f = fieldData[fk];
      f.FIELD_CONTROL = hasCorpQual ? "0" : "1";
      f.FIELD_REQUIRED = hasCorpQual ? "1" : "0";
      !hasCorpQual && _.set(f, "DEFAULT_VALUE", "");
    });
  },
  CHECK_NATIVE_PLACE__CLICK: function CHECK_NATIVE_PLACE__CLICK(_this, field, fields, module) {
    field.DEFAULT_VALUE = fields.ID_ADDR.DEFAULT_VALUE;
    var str = field.DEFAULT_VALUE;
    if (str == "") {
      _this.$blMethod.changeFieldError(field, false, "该项为必填项");
    } else if (str.replace(/[^\x00-\xff]/g, "xx").length > 32) {
      _this.$blMethod.changeFieldError(field, false, "请输入 1 到 32个字符，1个中文算2个字符");
    } else {
      field.showerr = false;
    }
  },
  CHECK_CORP_ADDR: function CHECK_CORP_ADDR(_this, field, fieldData, module) {
    _this.$nextTick(function () {
      if (!_this.oppBusiData.zipCodeList) {
        _this.oppBusiData.zipCodeList = [];
      }
      if (field.addressInfo && field.addressInfo[1] && field.addressInfo[1].length == 3) {
        var existCodeItem = _.find(_this.oppBusiData.zipCodeList, function (v) {
          return v.DICT_ITEM_NAME == field.addressInfo[1].join(",");
        });
        if (existCodeItem) {
          fieldData.ID_ZIP_CODE.DEFAULT_VALUE = existCodeItem.DICT_ITEM;
          return;
        }
        return _this.$blMethod.setZipCode(_this, field.addressInfo[1]).then(function (zipCode) {
          if (zipCode) {
            _this.oppBusiData.zipCodeList.push({
              DICT_ITEM: zipCode,
              DICT_ITEM_NAME: field.addressInfo[1].join(",")
            });
            fieldData.ID_ZIP_CODE.DEFAULT_VALUE = zipCode;
          }
        });
      }
    });
  },
  CHECK_CORP_ADDR__CLICK: function CHECK_CORP_ADDR__CLICK(_this, field, fieldData, module) {
    field.DEFAULT_VALUE = _.get(_this, "groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_ADDR.DEFAULT_VALUE");
  },
  "CHECK_STRUCT_PRO_FLAG": function CHECK_STRUCT_PRO_FLAG(_this, field, fieldData) {
    if (field.DEFAULT_VALUE) {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.INIT_LEVERAGE.FIELD_CONTROL = "0";
        fieldData.INIT_LEVERAGE.VALID_TYPE = "length[0,64]";
      } else {
        fieldData.INIT_LEVERAGE.FIELD_CONTROL = "1";
        fieldData.INIT_LEVERAGE.DEFAULT_VALUE = "";
      }
    }
  },
  CHECK_INDUS_GB: function CHECK_INDUS_GB(_this, field, fieldData) {
    _this.removeFlowTip("indusGbJ");
    if (field.DEFAULT_VALUE == "J") {
      _this.pushFlowTip({
        title: "客户填报的行业信息为“金融业”，该行业信息可能会影响客户的基金交易，请确认信息的准确性。",
        key: "indusGbJ",
        type: "warning"
      });
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOrg/bizOrgBasicInfoNode.js
// module id = 203
// module chunks = 2